<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <div class="body-2">{{labels.quoteInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.product" v-model="fireForm.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.product" :error-messages="errors.collect('product')" v-validate="'required'" @input="doProduct"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.scheme" v-model="fireForm.scheme" :label="labels.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="labels.scheme" :error-messages="errors.collect('scheme')" v-validate="'required'" @input="doScheme" :loading="schemeLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.duration" v-model="fireForm.duration" :label="labels.duration" item-text="label" item-value="value" data-vv-name="duration" :data-vv-as="labels.duration" :error-messages="errors.collect('duration')" v-validate="'required'" @input="doStartDate" :loading="durationLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs7 v-if="isStaff">
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['fireQuoteAcceptDate'])" @input="doAcceptDate" :max="maxStartDate"></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required|accept_today_date'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['fireQuoteAcceptDate'])" @input="doAcceptDate" :max="maxStartDate"></cal-picker-->
                </v-flex>
                 <v-flex xs7 v-else>
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['fireQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" :max="maxStartDate"></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['fireQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" :max="maxStartDate"></cal-picker-->
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="acceptTime" :label="labels.acceptTime" v-validate="'required'" :data-vv-as="labels.acceptTime" data-vv-name="acceptTime" :error-messages="errors.collect('acceptTime')" :readonly="!checkAccess(['fireQuoteAcceptDate'])" @input="doAcceptDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="fireForm.startDate" :label="labels.startDate" v-validate="startDateValidation" :data-vv-as="labels.startDate" data-vv-name="startDate" :error-messages="errors.collect('startDate')" @input="doStartDate" :min="this.acceptDate" :max="maxStartDate"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="fireForm.endDate" disabled :label="labels.endDate" v-validate="'required'" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" :min="this.fireForm.startDate"></cal-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card v-if="quoteParam.optCvr.length > 0" class="mt-3">
      <v-card-title>
        <div>
          <div class="body-2">{{labels.optCvr}}</div>
          <span class="grey--text">{{labels.optCvrInfo}}</span>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap v-for="optCvr in quoteParam.optCvr" :key="optCvr.riskNo + '-' + optCvr.itemNo">
            <v-flex xs6>
              <v-checkbox class="pt-3" v-model="tempForm.optCvr" :label="optCvr.description" :value="optCvr.riskNo + '-' + optCvr.itemNo"></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-text-field class="mavPrefix" v-if="optCvr.allowSI" :disabled="disableSI(optCvr.riskNo + '-' + optCvr.itemNo)" v-num-mask v-model="tempForm.optCvrSI[optCvr.riskNo + '-' + optCvr.itemNo]" :label="labels.optCvrSI" type="tel" :error-messages="errors.collect('optCvrSI')" data-vv-name="optCvrSI" :data-vv-as="labels.optCvrSI" v-validate="{ required: true, mask_decimal:2,  mask_min_value: optCvr.minSI, mask_max_value: optCvr.maxSI, pkg_opt_cvr: [optCvr.minSI, optCvr.incSI] }" :prefix="$store.state.agency.quotation.commonInfo.currPrefix"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <template v-if="renderFI">
        <v-card-title>
          <div>
            <div class="body-2">{{labels.addInfo}}</div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex lg6 xs12>
                <v-autocomplete :items="quoteParam.finInst" v-model="fireForm.finInst" :label="labels.finInst" item-text="label" item-value="value" data-vv-name="finInst" :data-vv-as="labels.finInst" :error-messages="errors.collect('finInst')" :persistent-hint="true" :hint="labels.finInstInfo"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div class="body-2">{{labels.cpInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.campaign" v-model="fireForm.campaign" :label="labels.campaign" item-text="label" item-value="value" data-vv-name="campaign" :data-vv-as="labels.campaign" :error-messages="errors.collect('campaign')" clearable :loading="campaignLoading" @input="doCampaign"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.promotion" v-model="fireForm.promotion" :label="labels.promotion" item-text="label" item-value="value" data-vv-name="promotion" :data-vv-as="labels.promotion" :error-messages="errors.collect('promotion')" clearable :loading="promotionLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import clone from 'clone'
import toDate from 'date-fns/toDate'
import addYears from 'date-fns/addYears'
import addMonths from 'date-fns/addMonths'
import addDays from 'date-fns/addDays'
import subDays from 'date-fns/subDays'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_FIRE_PARAM_GENERAL, QUOTE_FIRE_PARAM } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { expandURI } from '@/utils/ajax'
import { extractRecord } from '@/utils/extract'
import { formatDisplayTime, formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        product: 'Product*',
        scheme: 'Scheme*',
        duration: 'Duration*',
        acceptDate: 'Acceptance Date*',
        acceptTime: 'Time*',
        startDate: 'Start Date*',
        endDate: 'End Date*',
        quoteInfo: 'Quotation Information',
        optCvr: 'Optional Cover',
        optCvrSI: 'Sum Insured*',
        optCvrInfo: 'Sum Insured shall be based on reconstruction cost of the building',
        finInst: 'Finance Company',
        finInstInfo: 'The Financial Institution which the Building is mortgaged to',
        addInfo: 'Additional Information',
        cpInfo: 'Campaign/Promotion',
        campaign: 'Campaign',
        promotion: 'Promotion'
      },
      fireForm: {
        product: undefined,
        scheme: undefined,
        duration: undefined,
        acceptDate: undefined,
        startDate: undefined,
        endDate: undefined,
        finInst: undefined,
        campaign: undefined,
        promotion: undefined,
        optCvr: []
      },
      tempForm: {
        // as optCvr key is a composite key, we will convert it to string
        // we will merge it back to main form when submitting / loading in
        optCvr: [],
        optCvrSI: {}
      },
      acceptDate: undefined,
      acceptTime: undefined,
      schemeLoading: false,
      durationLoading: false,
      optCvrLoading: false,
      finInstLoading: false,
      campaignLoading: false,
      promotionLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    acceptDateValidation() {
      // return 'required|accept_back_date:' + this.backDateDays + '|accept_start_date:' + this.fireForm.startDate + '|accept_today_date'
      // return 'required|accept_back_date:' + this.backDateDays + '|accept_today_date'
      return 'required|accept_back_date:' + this.backDateDays
    },
    quoteParam() {
      return this.$store.state.agency.quotation.fireParam
    },
    globalFireForm() {
      return this.$store.state.agency.quotation.fireForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    isStaff() {
      return this.$store.state.agency.quotationSettings.isStaff
    },
    proceedLoading() {
      if (this.schemeLoading || this.durationLoading || this.optCvrLoading || this.finInstLoading || this.campaignLoading || this.promotionLoading) {
        return true
      } else {
        return false
      }
    },
    selectedProduct() {
      if (this.fireForm.product) {
        return extractRecord(this.quoteParam.product, this.fireForm.product)
      } else {
        return null
      }
    },
    backDateDays() {
      const product = this.selectedProduct
      if (product) {
        return product.backDateAcceptDays
      } else {
        return null
      }
    },
    backDateLimit() {
      if (this.backDateDays !== null || this.backDateDays !== undefined) {
        if (this.backDateDays === 0) {
          return new Date()
        } else {
          return subDays(new Date(), this.backDateDays)
        }
      } else return null
    },
    renderFI() {
      if (this.selectedProduct && this.selectedProduct.finInstOptCvr && this.tempForm.optCvr.length > 0) {
        return true
      }
      return false
    },
    daysBeforeCover() {
      if (this.fireForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.fireForm.product)
        if (productParam) {
          return productParam.maxDaysBeforeCover
        }
      }
      return undefined
    },
    minStartDate() {
      return new Date()
    },
    maxStartDate() {
      if (this.daysBeforeCover !== undefined) {
        let result = new Date()
        result.setHours(0, 0, 0, 0)
        result = addDays(result, this.daysBeforeCover)
        return result
      }
      return undefined
    },
    startDateValidation() {
      // return 'required|start_before_today|days_before_cover:' + this.daysBeforeCover
      return 'required|start_before_date:' + this.acceptDate + '|days_before_cover:' + this.daysBeforeCover
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.fireForm.product = this.globalCommonForm.product
      this.fireForm.scheme = this.globalCommonForm.scheme
      this.fireForm.duration = this.globalCommonForm.duration
      this.fireForm.acceptDate = this.globalCommonForm.acceptDate
      this.fireForm.startDate = this.globalCommonForm.startDate
      this.fireForm.endDate = this.globalCommonForm.endDate
      this.fireForm.finInst = this.globalCommonForm.finInst
      this.fireForm.campaign = this.globalCommonForm.campaign
      this.fireForm.promotion = this.globalCommonForm.promotion
      if (this.globalCommonForm.optCvr && this.globalCommonForm.optCvr.length > 0) {
        this.$set(this.fireForm, 'optCvr', clone(this.globalCommonForm.optCvr))
        for (const optCvr of this.globalCommonForm.optCvr) {
          this.tempForm.optCvr.push(optCvr.riskNo + '-' + optCvr.itemNo)
          this.$set(this.tempForm.optCvrSI, optCvr.riskNo + '-' + optCvr.itemNo, optCvr.si, optCvr.si)
        }
      }

      // Need break down acceptDate into date and time for input
      if (this.fireForm.acceptDate) {
        this.acceptDate = this.fireForm.acceptDate
        this.acceptTime = formatDisplayTime(this.fireForm.acceptDate)
      }

      // Check if there are already values in vuex form or if it is a fresh entry
      // For this case, we will just use product as an indicator (for review, there is already value saved)
      if (!this.fireForm.product) {
        if (this.quoteParam.product && this.quoteParam.product.length > 0) {
          // This is to load 1st value if its a fresh quotation
          this.fireForm.product = this.quoteParam.product[0].value
          this.doProduct()

          // Defaulting start Date
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          this.fireForm.startDate = today
          this.doStartDate()

          // As OptCvr etc will be snowballed from doProduct, we will leave those out
          this.getFinInst()
        }

        this.$store.commit(QUOTE_FIRE_PARAM_GENERAL)
      } else {
        // If there are already values in vuex, we will check if we still need to load Fire General Screen params
        if (!this.quoteParam.generalLoaded) {
          // doProduct will snowBall to get other params in general screen
          this.doProduct()
          this.getFinInst()

          this.$store.commit(QUOTE_FIRE_PARAM_GENERAL)
        }
      }
    },
    doProduct() {
      if (this.fireForm.product) {
        this.getConstrnCls()
      } else {
        this.fireForm.constrnCls = undefined
      }
      if (this.fireForm.product) {
        this.getScheme()
      } else {
        this.fireForm.scheme = undefined
        this.doScheme()
      }

      if (this.fireForm.acceptDate && this.fireForm.product) {
        this.getCampaign()
      } else {
        this.fireForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getConstrnCls() {
      // This is to fetch parameter for risk screen
      const apiURI = this.$store.state.agency.quotation.menu.constrnCls
      if (apiURI) {
        try {
          const expand = {
            product: this.fireForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              constrnCls: data.data
            }
            this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getScheme() {
      const apiURI = this.$store.state.agency.quotation.menu.scheme
      if (apiURI) {
        try {
          this.schemeLoading = true
          const expand = {
            product: this.fireForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              scheme: data.data
            }
            this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
          }
          this.schemeLoading = false

          // Defaulting for scheme (Default 1st if no value was set)
          if (!this.fireForm.scheme && this.fireForm.product && this.quoteParam.scheme && this.quoteParam.scheme.length > 0) {
            this.fireForm.scheme = this.quoteParam.scheme[0].value
          }

          if (this.fireForm.scheme && this.quoteParam.scheme && this.quoteParam.scheme.length > 0) {
            // Check if the current scheme value is still valid
            let schemeIsValid = false
            for (var i = 0; i < this.quoteParam.scheme.length; i++) {
              const scheme = this.quoteParam.scheme[i]
              if (scheme.value === this.fireForm.scheme) {
                schemeIsValid = true
                break
              }
            }
            // Invalid Scheme (reset to undefined)
            if (!schemeIsValid) {
              this.fireForm.scheme = undefined
              this.doScheme()
            } else {
              this.doScheme()
            }
          } else {
            this.fireForm.scheme = undefined
            this.doScheme()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.schemeLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doScheme() {
      if (this.fireForm.scheme) {
        this.getDuration()
        this.getOptCvr()
      } else {
        this.fireForm.duration = undefined
        this.fireForm.endDate = undefined
      }
    },
    async getDuration() {
      const apiURI = this.$store.state.agency.quotation.menu.duration
      if (apiURI) {
        try {
          this.durationLoading = true
          const expand = {
            scheme: this.fireForm.scheme
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              duration: data.data
            }
            this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
          }
          this.durationLoading = false

          // Defaulting for duration (Default 1st if no value was set)
          if (!this.fireForm.duration && this.fireForm.scheme && this.quoteParam.duration && this.quoteParam.duration.length > 0) {
            this.fireForm.duration = this.quoteParam.duration[0].value
          }

          if (this.fireForm.duration && this.quoteParam.duration && this.quoteParam.duration.length > 0) {
            // Check if the current duration value is still valid
            let durationIsValid = false
            for (var i = 0; i < this.quoteParam.duration.length; i++) {
              const duration = this.quoteParam.duration[i]
              if (duration.value === this.fireForm.duration) {
                durationIsValid = true
                break
              }
            }
            // Invalid Duration (reset to undefined)
            if (!durationIsValid) {
              this.fireForm.duration = undefined
              this.doStartDate()
            } else {
              this.doStartDate()
            }
          } else {
            this.fireForm.duration = undefined
            this.doStartDate()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.durationLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doStartDate() {
      if (this.fireForm.startDate && this.fireForm.duration) {
        const durationParam = extractRecord(this.quoteParam.duration, this.fireForm.duration)
        if (durationParam && durationParam.secondaryValue) {
          if (durationParam.thirdValue === 'Y') {
            // Add years to endDate
            let endDate = addYears(this.fireForm.startDate, durationParam.secondaryValue)
            endDate = subDays(endDate, 1)
            this.fireForm.endDate = endDate
          } else if (durationParam.thirdValue === 'M') {
            // Add months to endDate
            let endDate = addMonths(this.fireForm.startDate, durationParam.secondaryValue)
            endDate = subDays(endDate, 1)
            this.fireForm.endDate = endDate
          } else {
            // Add days by default
            let endDate = addDays(this.fireForm.startDate, durationParam.secondaryValue)
            endDate = subDays(endDate, 1)
            this.fireForm.endDate = endDate
          }
        }
      }
    },
    async getFinInst() {
      if (this.acceptDate) {
        const apiURI = this.$store.state.agency.quotation.menu.finInst
        if (apiURI) {
          try {
            this.finInstLoading = true
            const expand = {
              acceptDate: formatDisplayDate(this.acceptDate)
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data) {
              const { data } = result
              const commitResult = {
                finInst: data.data
              }
              this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
            }
            this.finInstLoading = false

            if (this.fireForm.finInst && this.quoteParam.finInst && this.quoteParam.finInst.length > 0) {
              // Check if the current duration value is still valid
              let finInstIsValid = false
              for (var i = 0; i < this.quoteParam.finInst.length; i++) {
                const finInst = this.quoteParam.finInst[i]
                if (finInst.value === this.fireForm.finInst) {
                  finInstIsValid = true
                  break
                }
              }
              // Invalid Duration (reset to undefined)
              if (!finInstIsValid) {
                this.fireForm.finInst = undefined
              }
            } else {
              this.fireForm.finInst = undefined
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            this.finInstLoading = false
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      }
    },
    async getOptCvr() {
      if (this.fireForm.scheme && this.acceptDate) {
        const apiURI = this.$store.state.agency.quotation.menu.optCvr
        if (apiURI) {
          try {
            this.optCvrLoading = true
            const expand = {
              scheme: this.fireForm.scheme,
              acceptDate: formatDisplayDate(this.acceptDate)
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data) {
              const { data } = result
              const commitResult = {
                optCvr: data.data
              }
              this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
            }
            this.optCvrLoading = false

            if (this.fireForm.optCvr && this.fireForm.optCvr.length > 0 && this.quoteParam.optCvr && this.quoteParam.optCvr.length > 0) {
              // Check if the current optCvr value is still valid
              for (const optCvr of this.fireForm.optCvr) {
                let optCvrIsValid = false
                for (const optCvrParam of this.quoteParam.optCvr) {
                  if (optCvr.riskNo === optCvrParam.riskNo && optCvr.itemNo === optCvrParam.itemNo) {
                    optCvrIsValid = true
                    break
                  }
                }
                if (!optCvrIsValid) {
                  // Invalid, Remove from form
                  this.fireForm.optCvr.splice(this.fireForm.optCvr.indexOf(this.fireForm.optCvr.find(x => x.riskNo === optCvr.riskNo && x.itemNo === optCvr.itemNo)), 1)
                  this.tempForm.optCvr.splice(this.tempForm.optCvr.indexOf(this.tempForm.optCvr.find(x => x === optCvr.riskNo + '-' + optCvr.itemNo)), 1)
                  this.$delete(this.tempForm.optCvrSI, optCvr.riskNo + '-' + optCvr.itemNo)
                }
              }
            } else {
              this.fireForm.optCvr = []
              this.tempForm.optCvr = []
              this.tempForm.optCvrSI = {}
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            this.optCvrLoading = false
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      } else {
        this.fireForm.optCvr = []
        const commitResult = {
          optCvr: []
        }
        this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
      }
    },
    doAcceptDate() {
      // Format Accept Date
      if (this.checkAccess(['fireQuoteAcceptDate'])) {
        if (this.acceptDate && this.acceptTime && this.acceptTime.length === 5) {
          const hr = this.acceptTime.substring(0, 2)
          const min = this.acceptTime.substring(3, 5)
          this.acceptDate = toDate(this.acceptDate)
          this.acceptDate.setHours(hr)
          this.acceptDate.setMinutes(min)
          this.fireForm.acceptDate = this.acceptDate
        }
      }
      this.getOptCvr()
      this.getFinInst()

      if (this.fireForm.product && this.fireForm.acceptDate) {
        this.getCampaign()
      } else {
        this.fireForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getCampaign() {
      const apiURI = this.$store.state.agency.quotation.menu.campaign
      if (apiURI) {
        try {
          const expand = {
            product: this.fireForm.product,
            intermediary: this.globalCommonForm.intermediary,
            acceptDate: formatDisplayDateTime2(this.fireForm.acceptDate)
          }
          this.campaignLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              campaign: data.data
            }
            this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
          }
          this.campaignLoading = false

          if (this.fireForm.campaign && this.quoteParam.campaign && this.quoteParam.campaign.length > 0) {
            // Check if the current campaign value is still valid
            let campaignIsValid = false
            for (var i = 0; i < this.quoteParam.campaign.length; i++) {
              const campaign = this.quoteParam.campaign[i]
              if (campaign.value === this.fireForm.campaign) {
                campaignIsValid = true
                break
              }
            }
            // Invalid Campaign (reset to undefined)
            if (!campaignIsValid) {
              this.fireForm.campaign = undefined
            } else { }
          } else {
            this.fireForm.campaign = undefined
          }
          // Do campaign (get promotion)
          this.doCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.campaignLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCampaign() {
      if (this.fireForm.campaign && this.fireForm.acceptDate) {
        this.getPromotion()
      } else {
        this.fireForm.promotion = undefined
      }
    },
    async getPromotion() {
      const apiURI = this.$store.state.agency.quotation.menu.promotion
      if (apiURI) {
        try {
          const expand = {
            campaign: this.fireForm.campaign,
            acceptDate: formatDisplayDateTime2(this.fireForm.acceptDate)
          }
          this.promotionLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              promotion: data.data
            }
            this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
          }
          this.promotionLoading = false

          if (this.fireForm.promotion && this.quoteParam.promotion && this.quoteParam.promotion.length > 0) {
            // Check if the current promotion value is still valid
            let promotionIsValid = false
            for (var i = 0; i < this.quoteParam.promotion.length; i++) {
              const promotion = this.quoteParam.promotion[i]
              if (promotion.value === this.fireForm.promotion) {
                promotionIsValid = true
                break
              }
            }
            // Invalid Promotion (reset to undefined)
            if (!promotionIsValid) {
              this.fireForm.promotion = undefined
            }
          } else {
            this.fireForm.promotion = undefined
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.resetMessages()
            this.message(data)
          }
          this.promotionLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    formatForm() {
      // Format OptCvr
      if (this.tempForm.optCvr.length > 0) {
        this.fireForm.optCvr = []
        for (const optCvr of this.tempForm.optCvr) {
          const optCvrSplit = optCvr.split('-')
          if (optCvrSplit.length === 2) {
            this.fireForm.optCvr.push({
              riskNo: optCvrSplit[0],
              itemNo: optCvrSplit[1],
              si: removeFormatNumber(this.tempForm.optCvrSI[optCvr])
            })
          }
        }
      } else {
        this.fireForm.optCvr = []
      }
    },
    disableSI(id) {
      if (this.tempForm.optCvr.find(x => x === id)) {
        return false
      }
      return true
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.fireForm.campaign && this.fireForm.promotion) || (!this.fireForm.campaign && !this.fireForm.promotion)) {
            this.formatForm()
            this.$store.dispatch('fireQuoteGeneral', this.fireForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
            this.$router.push({ name: 'fireQuotePlans' })
          } else {
            this.errorMessage('Please select a promotion if this quotation is participating in a campaign')
            this.promptFieldCheck()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.formatForm()
        await this.$store.dispatch('fireQuoteGeneral', this.fireForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style>
</style>
